module.exports = __webpack_public_path__ + "static/media/joyful_jeff.6329141c.jpg";